import { SECOND } from '../utils/time';

const RoundCount = 4;
const RoundPass = Math.floor(RoundCount * 0.8);

export default {
    name: 'Mental Rotation',
    level: [
        {
            practice: true,
            name: 'ทดลองเล่น',
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: 3,
            score: 1,
            passScore: 3,
        },
        {
            name: 'ระดับที่ 1 รูปตัวอักษร หมุน 120 องศา',
            level: 1,
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'ระดับที่ 2 รูปลูกบาศก์ หมุน 120 องศา',
            level: 2,
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'ระดับที่ 3 รูปสามมิติ หมุน 120 องศา',
            level: 3,
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        }
    ],
}